// extracted by mini-css-extract-plugin
module.exports = {"wrap":"VideoPlay_wrap__21ucX","video":"VideoPlay_video__2ekpd"};